module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/icon_facebook-ebd608b6647758298ee5d8c8122ea734.png";